import { useMemo } from 'react';

import { useShouldDisplayFields } from './useFieldDisplay';
import { getObjectKeys } from '../../../../utils/utils';

export const useVisibleFields = <T extends Record<string, unknown>>(fields: T): Partial<T> => {
    const fieldIds = useMemo(() => Object.keys(fields), [fields]);
    const visibleFieldIds = useShouldDisplayFields(fieldIds);

    const visibleFields = getObjectKeys(fields).reduce((acc, key) => {
        if (visibleFieldIds.includes(key as string)) {
            acc[key] = fields[key];
        }
        return acc;
    }, {} as Partial<T>);

    return visibleFields;
};
